const baseUrl = require('./baseUrl.config.js')

const apiUrl = `${baseUrl}api/`
module.exports = apiUrl